import {DocumentUpdateData} from "../types/document-update.types";

export const defaultDocumentUpdateData: DocumentUpdateData = {
  contract: {
    number: '',
    status: null,
    signedDocumentLink: '',
    date: null
  },
  erid: {
    number: ''
  },
  payment: {
    status: null,
    link: '',
    date: null
  },
  act: {
    status: null,
    actLink: '',
    receiptLink: '',
    date: null
  },
  edo: {
    status: null
  },
  oneC: {
    status: null,
    documentDiskLink: ''
  }
}
